/* Common JS for all pages.  Run at the end of the page, so could be deferred!  (hence the extra tests on domready) */
/* global gsap */

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main());
} else {
    main();
}

function main() {

    // Scroll to next section
    let scrollDown = document.getElementsByClassName("scroll-down");
    var pageName = window.location.pathname.split('/');
    const scrollDownLength = scrollDown.length;

    for (let i = 0; i < scrollDownLength; i++) {
        let currentSection = scrollDown[i].parentElement.parentElement;
        let nextSectionParent = currentSection.nextElementSibling;
        if (nextSectionParent !== null) {
            let nextSection = currentSection.nextElementSibling.firstElementChild;
            if (scrollDown[i] !== null && scrollDown[i] !== undefined && nextSection !== null && nextSection !== undefined) {
                if (pageName[1] == "") {
                    scrollDown[i].setAttribute("href", "#next" + [i]);
                    nextSection.setAttribute("id", "next" + [i]);
                } else {
                    scrollDown[i].setAttribute("href", pageName[1] + "/" + "#next" + [i]);
                    nextSection.setAttribute("id", "next" + [i]);
                }
            }
        }
    }


    // Activate animation on scroll

    let animate = document.getElementsByClassName('animation');
    let arrayLength = animate.length;
    for (let i = 0; i < arrayLength; i++) {
        function makeActive(entries) {
            entries.map((entry) => {
                if (entry.isIntersecting) {
                    animate[i].classList.add('animate')
                }
            });
        }

        const observer = new IntersectionObserver(makeActive);
        observer.observe(animate[i]);
    }
}











